import { render, staticRenderFns } from "./GeneralConfiguration.vue?vue&type=template&id=62eacf2b&scoped=true"
import script from "./GeneralConfiguration.vue?vue&type=script&lang=js"
export * from "./GeneralConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62eacf2b",
  null
  
)

export default component.exports